import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss'],
})
export class DisclaimerComponent implements OnInit {
  @Input('matIconName') matIconName!: string;
  @Input('message') message!: string;

  constructor() {}

  ngOnInit(): void {}
}
